import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, LockIcon, FileTextIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 10 * 60 + 52); // 02:10:52
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => prevTime > 0 ? prevTime - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section id="cta" ref={ref} className="w-full py-24 md:py-32 bg-[#110038] relative overflow-hidden" data-id="element-85">
      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-87">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-16 font-serif" data-id="element-88">
            Tu inversión en la relación
          </h2>

          <div className="bg-[#E0D7FF] rounded-[20px] border border-white p-10 md:p-14 shadow-[0_20px_50px_-20px_rgba(124,58,237,0.3)] border-t-8 border-t-[#7C3AED] relative" data-id="element-89">
            <div className="mb-10 flex flex-col items-center" data-id="element-90">
              {/* Urgency Timer */}
              <div className="mb-10 flex flex-col items-center" data-id="element-91">
                <div className="flex items-center gap-2 text-[#DC2626] font-bold text-lg mb-4 tracking-wide" data-id="element-92">
                  <span className="text-xl" data-id="element-93">⚠️</span>
                  LA OFERTA TERMINA PRONTO
                </div>
                <div className="flex items-center gap-3 text-white font-mono text-3xl md:text-4xl font-bold" data-id="element-94">
                  <div className="flex flex-col items-center gap-2" data-id="element-95">
                    <div className="bg-[#1a1a2e] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-96">
                      {Math.floor(timeLeft / 3600).toString().padStart(2, '0')}
                    </div>
                    <span className="text-[#3B1F6E] text-xs font-sans font-bold tracking-wider" data-id="element-97">
                      HORAS
                    </span>
                  </div>
                  <span className="text-[#1a1a2e] pb-6" data-id="element-98">:</span>
                  <div className="flex flex-col items-center gap-2" data-id="element-99">
                    <div className="bg-[#1a1a2e] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-100">
                      {Math.floor(timeLeft % 3600 / 60).toString().padStart(2, '0')}
                    </div>
                    <span className="text-[#3B1F6E] text-xs font-sans font-bold tracking-wider" data-id="element-101">
                      MIN
                    </span>
                  </div>
                  <span className="text-[#1a1a2e] pb-6" data-id="element-102">:</span>
                  <div className="flex flex-col items-center gap-2" data-id="element-103">
                    <div className="bg-[#DC2626] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-104">
                      {(timeLeft % 60).toString().padStart(2, '0')}
                    </div>
                    <span className="text-[#DC2626] text-xs font-sans font-bold tracking-wider" data-id="element-105">
                      SEG
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center gap-2 mb-4" data-id="element-106">
                <span className="text-2xl text-[#6B5B8D] line-through font-medium opacity-80 font-sans" data-id="element-107">
                  $24.999
                </span>
                <div className="text-6xl md:text-7xl font-bold text-[#1E0A3C] font-serif tracking-tight" data-id="element-108">
                  $9.999{' '}
                  <span className="text-2xl font-normal text-[#1E0A3C]/70 font-sans tracking-normal" data-id="element-109">
                    ARS
                  </span>
                </div>
              </div>
              <p className="text-[#3B1F6E] font-medium text-lg font-sans" data-id="element-110">
                Acceso inmediato de por vida a todo el contenido
              </p>
            </div>

            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(5, 150, 105, 0)', '0 0 0 15px rgba(5, 150, 105, 0.2)', '0 0 0 0 rgba(5, 150, 105, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="w-full bg-[#059669] text-white px-8 py-6 rounded-xl text-xl font-semibold shadow-[0_10px_25px_-5px_rgba(5,150,105,0.5)] hover:bg-[#047857] transition-colors flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 mb-10 font-sans tracking-wide" data-id="element-111">
              <div className="flex items-center gap-2" data-id="element-112">
                <DownloadIcon className="w-6 h-6" data-id="element-113" />
                <span data-id="element-114">COMPRAR AHORA</span>
              </div>
            </motion.a>

            {/* Guarantee Box */}
            <div className="bg-[#F3F0FF] border border-[#C4B5FD] rounded-2xl p-6 mb-8 flex flex-col items-center text-center gap-3" data-id="element-115">
              <ShieldCheckIcon className="w-8 h-8 text-[#7C3AED]" strokeWidth={1.5} data-id="element-116" />
              <p className="text-[#1E0A3C] font-medium leading-relaxed font-sans" data-id="element-117">
                Si no te sirve, te devolvemos tu dinero.
                <br data-id="element-118" />
                <span className="text-[#6B5B8D]" data-id="element-119">7 días de garantía.</span>
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm text-[#3B1F6E] pt-8 border-t border-[#C4B5FD] font-sans font-medium" data-id="element-120">
              <div className="flex items-center gap-2" data-id="element-121">
                <LockIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-122" />
                Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-123">
                <DownloadIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-124" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-125">
                <FileTextIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-126" />
                PDF
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}